import axios from 'axios';

const axios8000 = axios.create({
  baseURL: 'https://ussalescoachfrontend-api-app-aihhyoej2q-ue.a.run.app',
});
// const axios8000 = axios.create({
//   baseURL: 'http://localhost:8000', // Set the base URL here
// });
export default axios8000;
